import { memo } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';

/**
 * Citation accordion header component
 * Displays icon, title, and optional match score
 *
 * Memoized to prevent unnecessary re-renders when parent updates
 */
export const ChatCitationHeader = memo(function ChatCitationHeader({
  sourceType,
  title,
  score,
  index,
  showIndex,
}) {
  const { t } = useTranslation();
  const isKB = sourceType === 'knowledge_base';
  const sourceIconName = isKB ? 'lucide:file-text' : 'lucide:globe';

  return (
    <div className="flex items-center w-full text-xs gap-2">
      <Icon icon={sourceIconName} className="size-4 flex-shrink-0 text-subtle" />
      <strong className="flex-1 min-w-0 break-all overflow-hidden">
        {showIndex && `${index + 1}. `}
        {title}
      </strong>
      {score !== null && score !== undefined && isKB && (
        <span className="text-muted text-xs flex-shrink-0 whitespace-nowrap">
          {t('chat.citation.match', 'Match')}: {Math.round(score * 100)}%
        </span>
      )}
    </div>
  );
});

ChatCitationHeader.propTypes = {
  sourceType: PropTypes.string,
  title: PropTypes.string.isRequired,
  score: PropTypes.number,
  index: PropTypes.number.isRequired,
  showIndex: PropTypes.bool.isRequired,
};
